module.exports = function (settingsService) {
    return {
        restrict: 'E',
        scope: {
            settingGroup: '@',
            settingName: '@',
        },
        link(scope) {
            settingsService.getSettingValue(scope.settingGroup, scope.settingName).then((value) => {
                scope.settingValue = value;
            });
        },
        template: '{{settingValue}}',
    };
};



// WEBPACK FOOTER //
// ./src/common/settings/settings.directive.js